import React, { Component } from "react";
import DataTable from "react-data-table-component";

class DataTableComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <DataTable
                data={this.props.data}
                title={this.props.title}
                columns={this.props.columns}
                noHeader={this.props.noHeader}
                className={this.props.className}
                responsive={this.props.responsive}
                noTableHead={this.props.noTableHead}
                onRowClicked={this.props.onRowClicked}
                noContextMenu={this.props.noContextMenu}
                expandableRows={this.props.expandableRows}
                paginationPerPage={this.props.paginationPerPage}
                expandableRowsComponent={this.props.expandableRowsComponent}
                selectableRowsComponent={this.props.selectableRowsComponent}
                highlightOnHover={this.props.highlightOnHover}
                pagination={this.props.pagination} 
                
                noDataComponent={this.props.noDataComponent? 
                    this.props.noDataComponent
                    :
                    <p className='text-center'>Sem dados para exibir</p>
                }
            />
        );
    }
}

export default DataTableComp;



// WEBPACK FOOTER //
// ./src/components/theme/data-table/index.jsx